import React, { useEffect, useState } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import styles from './Home.module.css';
import i18next from 'i18next';
import Typist from 'react-typist';
import Footer from '../../footer/Footer';
import { Row, Col } from 'react-bootstrap';
import IsItComponent from './IsItComponent';
import {
  defaultPreviewLinkImage,
  defaultPreviewLinkDescription,
  color,
  employeesNumber,
  branchesNumber,
  origin,
  dairy,
  halal,
  kosher,
  vegetarian,
  oceanWise,
  msc,
  asc,
  constituent,
  packaging,
  organic,
  mealCare,
  communityEngage,
} from '../../../stocateConstants';
import plusButton from '../../../assets/images/home/plusButton.png';
import AppStore from '../../../assets/images/home/appStoreButton.png';
import PlayStore from '../../../assets/images/home/playStoreButton.png';
import HomeLogo from '../../../assets/images/home/homeLogo.png';
import FeedbackIcon from '../../../assets/images/general/feedback.png';
import Feedback from '../feedback/Feedback';
import Modal from 'react-modal';
// import DropdownBanner from '../../../components/reusable/DropdownBanner';
import navStyles from '../../navigation-bar/NavigationBar.module.css';
import homeCardIcon1 from '../../../assets/images/home/home-card-icon-1.png';
import homeCardIcon2 from '../../../assets/images/home/home-card-icon-2.png';
import homeCardIcon3 from '../../../assets/images/home/home-card-icon-3.png';
import homeCardIcon4 from '../../../assets/images/home/home-card-icon-4.png';
import homeSection1Ss from '../../../assets/images/home/home-section-1-ss.png';
import homeSection3Ss from '../../../assets/images/home/home-section-3-ss.png';

interface Badge {
  key: number;
  labelKey: string;
  image: string;
}
const isMobile = window.innerWidth <= 768;
const Home = () => {
  const [count, setCount] = useState(1);
  function updateMetaTags() {
    document
      .querySelector('meta[name="og:title"]')
      ?.setAttribute('content', 'Stocate');
    document
      .querySelector('meta[name="og:image"]')
      ?.setAttribute('content', defaultPreviewLinkImage);
    document
      .querySelector('meta[name="og:url"]')
      ?.setAttribute('content', 'https://stocate.com/');
    document
      .querySelector('meta[name="og:description"]')
      ?.setAttribute('content', defaultPreviewLinkDescription);
  }

  useEffect(() => {
    setCount(1);
    updateMetaTags();
  }, [count]);

  const getCorrectBadgeVersion = (badgeList: Badge[], index: number) => {
    return badgeList.filter((badge) => badge.key === index);
  };

  const WorthItBadges = [
    {
      key: 1,
      labelKey: 'home.priceBadgeOption',
      image: require('../../../assets/images/home/homeBadges/Price.png'),
    },
    {
      key: 1,
      labelKey: 'home.qualityBadgeOption',
      image: require('../../../assets/images/home/homeBadges/Quality.png'),
    },
    {
      key: 1,
      labelKey: 'home.distBadgeOption',
      image: require('../../../assets/images/home/homeBadges/Distance.png'),
    },
  ];

  const modalStyle = {
    overlay: {
        zIndex: '7',
        backgroundColor: 'rgba(220, 220, 220, 0.8)',
    },
    content: {
        top: isMobile ? '20vh' : '10px',
        left: isMobile ? '5%' : undefined,
        height: isMobile ? '55vh' : 'auto',
        minHeight: isMobile ? '50vh' : 'auto',
        padding: isMobile ? '5%' : '1%',
        width: isMobile ? '90%' : '60%',
        margin: isMobile ? '50px auto 20px auto' : '4% 17%',
        borderRadius: isMobile ? '8px' : '4%',
    },
  };
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const [appModalIsOpen, setAppModalIsOpen] = useState(false);
  const toggleAppModal = () => setAppModalIsOpen(!appModalIsOpen);

  function closeAppModal() {
    setAppModalIsOpen(false);
    setIsHovered(false);
  }

  function goToSignUp() {
    window.location.pathname = '/signup';
  }

  function goToTutorial() {
    window.location.pathname = '/testing/register';
  }
  function goToAddItem() {
    window.location.pathname = '/add/item';
  }
  function goToAddStore() {
    window.location.pathname = '/add/store';
  }
  function goToBrowse() {
    window.location.pathname = '/browse';
  }
  function goToAddList() {
    window.location.pathname = '/add/list';
  }
  function goToList() {
    window.location.pathname = '/lists';
  }
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const appButtonStyles = {
    base: {
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: '8px 12px',
      borderRadius: '4px',
      transition: 'all 0.3s ease',
      color: '#333',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      ...(isHovered && {
        background: '#00809E',
        Opacity: '0.8',
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        color: '#FFFFFF',
      }),
      ...(isActive && {
        transform: 'translateY(0)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      }),
    },
  };
  const cardData = [
    {
      icon: homeCardIcon1,
      text: 'Post products and businesses that you like',
      targetId: 'section1',
    },
    {
      icon: homeCardIcon2,
      text: 'Tell us what makes them sustainable',
      targetId: 'section2',
    },
    {
      icon: homeCardIcon3,
      text: 'Remember your favourite items and stores',
      targetId: 'section3',
    },
    {
      icon: homeCardIcon4,
      text: 'Strengthen the community',
      targetId: 'section4',
    },
  ];
  const spanCoordinates = isMobile ? { top: '23px', left: '72px' } : { top: '25.5px', left: '93px' };
  return (
    <div className={styles.container}>
      <div className={styles.centered}>
        <Col>
          <span>
            <Row style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                className={styles.trouble}
                style={{ whiteSpace: 'pre-line' }}
              >
                {i18next.t('home.trouble1')}
              </div>
              <div
                className={styles.troubleSubtitle}
                style={{ whiteSpace: 'pre-line' }}
              >
                {i18next.t('home.troubleSubtitle')}
              </div>
              <div
                className={styles.troubleSubtitle2}
                style={{ whiteSpace: 'pre-line' }}
              >
                {i18next.t('home.trouble2')}
              </div>
            </Row>
            <div className={styles.buttonGroup}>
              <Row>
                <button
                  className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                  onClick={toggleAppModal}
                >
                  {i18next.t('titles.app_store')}
                </button>
                <button
                  className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                  onClick={goToSignUp}
                >
                  {i18next.t('titles.signup')}
                </button>
                <button
                  className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                  onClick={goToTutorial}
                >
                  {i18next.t('titles.pilottest')}
                </button>
              </Row>
            </div>
            {appModalIsOpen && (
              <Modal
                isOpen={appModalIsOpen}
                onRequestClose={closeAppModal}
                style={modalStyle}
              >
                <div style={{ textAlign: 'right' }}>
                  <button
                    type='button'
                    onClick={closeAppModal}
                    style={appButtonStyles.base}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onMouseDown={() => setIsActive(true)}
                    onMouseUp={() => setIsActive(false)}
                  >
                    ×
                  </button>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '20px',
                    gap: '20px',
                  }}
                >
                  <img
                    src={HomeLogo}
                    alt='stocateLogo'
                    className={styles.homeLogo}
                  ></img>
                  <span
                    style={{
                      color: '#00809E',
                      fontSize: '27px',
                      fontWeight: '550',
                    }}
                  >
                    Join us today
                  </span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '40px',
                    }}
                  >
                    <a
                      target='_blank'
                      rel='noreferrer'
                      href='https://play.google.com/store/apps/details?id=com.stocate.stocatepilot'
                    >
                      <img
                        src={PlayStore}
                        alt='play store'
                        style={{ width: '120px' }}
                      />
                    </a>
                    <a
                      target='_blank'
                      rel='noreferrer'
                      href='https://apps.apple.com/ca/app/stocate/id1579972656'
                      style={{ width: '120px' }}
                    >
                      <img
                        src={AppStore}
                        alt='app store'
                        style={{ width: '120px' }}
                      />
                    </a>
                  </div>
                </div>
              </Modal>
            )}
          </span>
        </Col>
        <Col className={styles.centered} style={{ padding: '40px 0' }}>
          <img
            src={HomeLogo}
            alt='stocateLogo'
            className={styles.homeLogo}
          ></img>
        </Col>

      </div>
      <div style={{ backgroundColor: '#82c8d7' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '40px',
            marginBottom: '60px',
          }}
        >
          <span
            style={{ color: '#00809E', fontSize: '40px', fontWeight: '550' }}
          >
            Use Stocate to...
          </span>
          <div
            className={styles.cardContainer}
          >
            {cardData.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  const section = document.getElementById(item.targetId);
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className={styles.card}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = 'scale(1.03)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = 'scale(1)')
                }
                onMouseDown={(e) =>
                  (e.currentTarget.style.transform = 'scale(0.97)')
                }
                onMouseUp={(e) =>
                  (e.currentTarget.style.transform = 'scale(1.03)')
                }
              >
                <img
                  src={item.icon}
                  alt='icon'
                  style={{
                    width: '60px',
                    height: '60px',
                    marginBottom: '16px',
                  }}
                />
                <p
                  style={{
                    color: '#2d7a9a',
                    textAlign: 'center',
                    fontSize: '22px',
                    fontWeight: '500',
                  }}
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* section 1*/}
      <div
        className= {styles.sectionContainer}
        style={{
          backgroundColor: color.white,
        }}
        id='section1'
      >
        <div
          className={styles.sectionTitle}
        >
          {i18next.t('home.section1')}
        </div>
        <div className={styles.sectionDescription}>
          <Trans
            i18nKey='home.section1_description'
            components={{
              b: <b />,
              br: <br />,
              buttonPlaceholder1: (
                <button
                  className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                  onClick={goToAddItem}
                ></button>
              ),
              buttonPlaceholder2: (
                <button
                  className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                  onClick={goToAddStore}
                ></button>
              ),
            }}
          />
        </div>
        <div>
          <img
            src={homeSection1Ss}
            alt='home section 1'
            style={{
              width: '80%',
              height: 'auto',
              marginTop: '20px',
              marginBottom: '20px',
              display: 'block',
              borderRadius: '8px',
              marginLeft: 'auto',
              marginRight: 'auto',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s',
              cursor: 'pointer',
            }}
            onClick={goToBrowse}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = 'scale(1.03)')
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            onMouseDown={(e) =>
              (e.currentTarget.style.transform = 'scale(0.97)')
            }
            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
          />
        </div>
      </div>

      {/* section 2*/}
      <div
        className={styles.sectionContainer}
        style={{
          backgroundColor: color.veryLightGray,
        }}
        id='section2'
      >
        <div
          className={styles.sectionTitle}
        >
          {i18next.t('home.section2')}
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: i18next.t('home.section2_description'),
          }}
          className={styles.sectionDescription}
        />
        <div className={styles.isItContainer}>
          <Row
            className={`${styles.row} ${styles.isItContainer}`}
            style={{ width: '80%' }}
          >
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.worth_title')}
                badges={WorthItBadges}
                badgeDescs={[
                  i18next.t('home.priceBadge'),
                  i18next.t('home.qualityBadge'),
                  i18next.t('home.distBadge'),
                ]}
                filters={['', '', '']}
              />
            </Col>
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.local_title')}
                badges={getCorrectBadgeVersion(
                  [...employeesNumber, ...branchesNumber, ...origin],
                  1
                )}
                badgeDescs={[
                  i18next.t('newStore.full_time_employees'),
                  i18next.t('newStore.branches_in_total'),
                  i18next.t('newStore.origin'),
                ]}
                filters={['EmployeesNumber', 'BranchesNumber', '']}
              />
            </Col>
            <Col sm={6} lg={4}>
              <div style={{ position: 'relative' }}>
                <IsItComponent
                  titleText={i18next.t('home.is_it_title')}
                  badges={getCorrectBadgeVersion(
                    [...kosher, ...dairy, ...vegetarian, ...halal],
                    0
                  )}
                  badgeDescs={[
                    i18next.t('newStore.kosher'),
                    i18next.t('newStore.dairy'),
                    i18next.t('newStore.vegetarian'),
                    i18next.t('newStore.halal'),
                  ]}
                  filters={['', '', '']}
                />
                <span
                  style={{
                    position: 'absolute',
                    top: spanCoordinates.top,
                    left: spanCoordinates.left,
                  }}
                >
                  {count ? (
                    <Typist
                      avgTypingDelay={50}
                      onTypingDone={() => setCount(0)}
                      cursor={{ show: false }}
                    >
                      <h1 className={styles.isItTitle}>
                        {' '}
                        {i18next.t('home.dietary_kosher')}
                      </h1>
                      <Typist.Backspace
                        count={i18next.t('home.dietary_kosher').length}
                        delay={800}
                      />
                      <h1 className={styles.isItTitle}>
                        {' '}
                        {i18next.t('home.dietary_dairy')}
                      </h1>
                      <Typist.Backspace
                        count={i18next.t('home.dietary_dairy').length}
                        delay={800}
                      />
                      <h1 className={styles.isItTitle}>
                        {' '}
                        {i18next.t('home.dietary_vegetarian')}
                      </h1>
                      <Typist.Backspace
                        count={i18next.t('home.dietary_vegetarian').length}
                        delay={800}
                      />
                      <h1 className={styles.isItTitle}>
                        {' '}
                        {i18next.t('home.dietary_halal')}
                      </h1>
                      <Typist.Backspace
                        count={i18next.t('home.dietary_halal').length}
                        delay={800}
                      />
                    </Typist>
                  ) : (
                    ''
                  )}
                </span>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.humane_title')}
                badges={getCorrectBadgeVersion(
                  [...oceanWise, ...msc, ...asc],
                  0
                )}
                badgeDescs={[
                  i18next.t('newStore.oceanWise'),
                  i18next.t('newStore.msc'),
                  i18next.t('newStore.asc'),
                ]}
                filters={['', '', '']}
              />
            </Col>
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.green_title')}
                badges={[
                  ...getCorrectBadgeVersion([...constituent, ...packaging], 1),
                  ...getCorrectBadgeVersion([...organic], 0),
                ]}
                badgeDescs={[
                  i18next.t('newStore.constituents'),
                  i18next.t('newStore.type_packaging'),
                  i18next.t('newStore.organic'),
                ]}
                filters={['', '', '']}
              />
            </Col>
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.community_title')}
                badges={[
                  ...getCorrectBadgeVersion([...mealCare], 0),
                  ...getCorrectBadgeVersion([...communityEngage], 1),
                ]}
                badgeDescs={[
                  i18next.t('newStore.mealCare'),
                  i18next.t('newStore.communityEngage'),
                ]}
                filters={['Mealcare', 'CommunityEngage']}
              />
            </Col>
            <Col sm={6} lg={4}>
              <IsItComponent
                titleText={i18next.t('home.it_it_title')}
                badgeDescs={[
                  i18next.t('newStore.mealCare'),
                  i18next.t('newStore.communityEngage'),
                ]}
                filters={['Mealcare', 'CommunityEngage']}
              />
            </Col>
          </Row>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={plusButton}
            style={{ height: '50px', width: '50px' }}
            alt='plus button'
          />
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: i18next.t('home.section2_description2'),
          }}
          className={styles.sectionDescription}
          style={{ maxWidth: '300px', textAlign: 'center' }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={openModal}
          onMouseEnter={(e) => (e.currentTarget.style.cursor = 'pointer')}
          onMouseLeave={(e) => (e.currentTarget.style.cursor = 'default')}
        >
          <img
            src={FeedbackIcon}
            style={{ height: '50px', width: '50px' }}
            alt='feedback button'
          />
        </div>
      </div>
      <div>
        {/* section 3*/}
        <div
          className={styles.sectionContainer}
          style={{
            backgroundColor: color.white,
          }}
          id='section3'
        >
          <div
            className={styles.sectionTitle}
          >
            {i18next.t('home.section3')}
          </div>
          <div className={styles.sectionDescription}>
            <Trans
              i18nKey='home.section3_description'
              components={{
                b: <b />,
                br: <br />,
                buttonPlaceholder1: (
                  <button
                    className={`${navStyles.buttonLight} ${navStyles.button} ${styles.buttonContainer}`}
                    onClick={goToAddList}
                  ></button>
                ),
              }}
            />
          </div>
          <div>
            <img
              src={homeSection3Ss}
              alt='home section 3'
              style={{
                width: '80%',
                height: 'auto',
                marginTop: '20px',
                marginBottom: '20px',
                display: 'block',
                borderRadius: '8px',
                marginLeft: 'auto',
                marginRight: 'auto',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                transition: 'transform 0.2s',
                cursor: 'pointer',
              }}
              onClick={goToList}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'scale(1.03)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'scale(1)')
              }
              onMouseDown={(e) =>
                (e.currentTarget.style.transform = 'scale(0.97)')
              }
              onMouseUp={(e) =>
                (e.currentTarget.style.transform = 'scale(1.03)')
              }
            />
          </div>
        </div>
        {/* section 4*/}
        <div
          className={styles.sectionContainer}
          style={{
            backgroundColor: color.veryLightGray,
          }}
          id='section4'
        >
          <div
            className={styles.sectionTitle}
          >
            {i18next.t('home.section4')}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: i18next.t('home.section4_description'),
            }}
            className={styles.sectionDescription}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '20px',
            }}
            onClick={openModal}
            onMouseEnter={(e) => (e.currentTarget.style.cursor = 'pointer')}
            onMouseLeave={(e) => (e.currentTarget.style.cursor = 'default')}
          >
            <img
              src={FeedbackIcon}
              style={{ height: '50px', width: '50px' }}
              alt='feedback button'
            />
          </div>
        </div>
      </div>

      {/* section 5*/}
      <div
        className={styles.sectionContainer}
        style={{
          backgroundColor: '#E0F3F9',
          paddingBottom: isMobile ? '50px' : undefined,
          marginBottom: isMobile ? undefined : '10px',
        }}
      >
        <div
          className={styles.sectionTitle}
          style={{ fontWeight: '600', fontSize: '50px' }}
        >
          {i18next.t('home.section5')}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={modalStyle}
      >
        <Feedback hide={closeModal}></Feedback>
      </Modal>
      <Footer />
      {/* <DropdownBanner/> */}
    </div>
  );
};
export default withTranslation()(Home);
